import { bridgeApi } from '../network'

export async function verifyPhoneNumberFunction(suppliedData) {
  const { data } = await bridgeApi.post('/signup/bridge/generateOTP', {
    phoneNumber: suppliedData.phoneNumber,
  })
  return data
}

export async function verifyOtpFunction(suppliedData) {
  const { data } = await bridgeApi.post(
    '/signup/bridge/verifyOtpAndGenerateToken',
    {
      phoneNumber: suppliedData.phoneNumber,
      password: suppliedData.password,
    }
  )
  return data
}

export async function getDsaList() {
  const { data } = await bridgeApi.get('/enterprise/subAgent/getDsaList')
  return data?.data
}

export async function submitSelectedDsa(id) {
  const { data } = await bridgeApi.post(`/enterprise/subAgent/refreshToken`, {
    dsaId: id,
  })

  return data
}

export async function saveUserDetails(suppliedData) {
  const { data } = await bridgeApi.post(
    '/enterprise/bridgeEvent/getNextState',
    {
      data: {
        event: 'SHOWN_BRIDGE_ONBOARDING_SCREEN',
        eventData: {
          name: suppliedData?.name,
          email: suppliedData?.email,
          panNumber: suppliedData?.panNumber?.toUpperCase(),
        },
      },
    }
  )

  return data
}

export async function updateProfilePic(imageFormData) {
  const { data } = await bridgeApi.put(
    '/enterprise/subAgent/updateProfilePic',
    imageFormData,
    {
      headers: {
        'content-type': 'multipart/form-data',
      },
    }
  )
  return data
}
